/**
 * Compares two date strings and returns true if both are the same date (i.e. without taking the time into consideration)
 */
const isSameDate = (date1: string, date2: string) =>
  String(new Date(date1).getTime()).slice(0, -4) === String(new Date(date2).getTime()).slice(0, -4);

export default isSameDate;
